export const getPackagingDisplayPayload = packaging => {
  return packaging?.map((item, index) => ({
    enabled: item.is_enabled,
    id: item.id,
    position: index,
  }))
}
